import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type FlightProvidersState = {
  fetching: FetchingStatus | null;
  value: string[] | null;
};

const initialState: FlightProvidersState = {
  fetching: null,
  value: null,
};

function setFetchingFunction(state: FlightProvidersState, action: PayloadAction<FlightProvidersState['fetching']>) {
  return {
    ...state,
    fetching: action.payload,
  };
}

function setFlightProvidersFunction(state: FlightProvidersState, action: PayloadAction<FlightProvidersState['value']>) {
  return {
    ...state,
    value: action.payload,
  };
}

const slice = createSlice({
  name: 'dataService.productProviders.flight',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setFlightProviders: setFlightProvidersFunction,
  },
});

export const { setFetching, setFlightProviders } = slice.actions;
export default slice.reducer;
